import axios from 'axios';

export function performEnrichAllContactsAction() {
    return axios.post(`/api/?entity=contacts&action=enrichAllContacts`)
        .then(response => response.data);
}
